import { create } from 'zustand';

interface ChatStore {
  shouldRefreshHistory: boolean;
  setShouldRefreshHistory: (value: boolean) => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  shouldRefreshHistory: false,
  setShouldRefreshHistory: (value) => set({ shouldRefreshHistory: value }),
})); 